/**
 * "Pour la taille, on part sur quoi ?" on desktop (PosterBaseScreen, the cards of
 * shared.components.PosterSizeOptions). On mobile the same choices open in a sheet
 * (shared.popups.PosterOptionsSheet).
 */
fx.ns("shared.screens", class PosterSizeScreen extends shared.screens.PosterBaseScreen
{
    makeChoices()
    {
        return new shared.components.PosterSizeOptions(this.data, { mobile : false });
    }

    get upsellEvent()
    {
        return "upsell-selected";
    }
});
